<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

definePageMeta({
    middleware: ['redirect'],
    auth: true, // This marks the page as auth-protected
    ignoreOnBoarding: true,
    parking: true, // This marks the page as a parking page
    parkingOverviewPage: true
})

// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)

// Get center details
const { data: centerDetails, suspense: centerDetailSuspense } = useFetchCenterDetails(centerRoute.value)

onServerPrefetch(async () => {
    await centerDetailSuspense()
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Seo
useSeoMeta({
    title: () => `${staticKeys.value?.parkingfirstpage_headline} | ${centerDetails.value?.centerName}`
})

// Set viewport content to prevent zoom
useHead({
    meta: [
        {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0'
        }
    ]
})
</script>

<template>
    <PageMainContainer :page-main-container-config="{ appFooter: false }">
        <ParkingPayment />
    </PageMainContainer>
</template>
